import styled from 'styled-components';

import Text from 'common/typography/Text/Text';
import Loading from '../../../../../common/components/atoms/Loading';

export const TrendChartContainer = styled.div`
  position: relative;
  ${props => (props.optionsVisible ? 'width: calc(100% - 220px);' : 'width: 100%;')};
  ${props => (props.chartHeight ? `min-height: ${props.chartHeight};` : '')};
`;

export const Hidden = styled.div`
  opacity: 0;
`;

export const AbsoluteLoading = styled(Loading)`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e4e4e447;
  z-index: 2;
`;

export const OverlayLoadingMessage = styled(Text)`
  margin-top: 8px;
  font-size: 0.85em;
  color: ${props => props.theme.colors.darkGray || '#555'};
`;
